<template>
  <div>
    <button
        v-if="!canHide || (canHide && !isInCart)"
        :class="isInCart ? disableClass : enableClass"
        type="submit"
        :disabled="isInCart"
        @click="clickedAdd">
        <i class="bi bi-cart-plus-fill"></i>
    </button>
  </div>
</template>

<script lang="ts">
import { Options, Vue, prop } from "vue-class-component";

import { useCartStore } from "@/stores/cart";
import { usePhotoStore } from "@/stores/photo";

// Define props in a class
class ButtonAddToCartProps {
  item = prop({
    // Same as Vue core's prop option
    type: Object,
    required: true,
    default: {}
  })
  canHide = prop({
    // Same as Vue core's prop option
    type: Boolean,
    required: false,
    default: false
  })
}

@Options({
  components: {
  }
})
export default class ButtonAddToCart extends Vue.with(ButtonAddToCartProps) {
  cartStore = useCartStore()
  photoStore = usePhotoStore()

  enableClass = "text-white rounded-circle btn btn-primary opacity-100"
  disableClass = "text-white rounded-circle btn btn-primary opacity-25"

  get isInCart() {
    return this.cartStore.isInCart(this.item.id)
  }

  public clickedAdd() {
    console.log("clickedAdd")

    this.cartStore.putInCart(this.item)
  }
}
</script>

<style lang="stylus">
</style>
